import { Pipe, PipeTransform } from '@angular/core';
import { FormComponentForPdf } from '@core/typings/pdf.typing';
import { ComponentHelperService } from '@features/forms/services/component-helper/component-helper.service';

@Pipe({
    name: 'gcGetComponentApplicableForPDF',
    standalone: false
})
export class GetComponentApplicableForPDFPipe implements PipeTransform {

  constructor (
    private componentHelper: ComponentHelperService
  ) { }

  transform (comp: FormComponentForPdf): boolean {
    return this.componentHelper.isComponentApplicableForPdf(comp, false);
  }
}
